import React from "react";
import { Helmet } from "react-helmet";
import Mission from '../recruitPage/components/mission';
import Benefits from '../recruitPage/components/benefits';
import Activities from '../recruitPage/components/activities';
import Footer from '../recruitPage/components/footer';
import styles from '../css/Recruit.module.css';

function Page() {
  const pageTitle = "Craftsman Software | 採用情報";
  const websiteUrl = "https://craftsman-software.com/recruit";
  const companyDescription =
    "Craftsman Softwareでは一緒に働く仲間を募集しています。"; // TODO: DatoCMSのSEO設定からデータを取得する

  return (
    <div>
      <Helmet>
        <title>{pageTitle}</title>
        <meta name="description" content={companyDescription} />
        <link rel="icon" href="/favicon.ico" />
        <link
          rel="apple-touch-icon"
          type="image/png"
          href="/apple-touch-icon-180x180.png"
        />
        <link rel="icon" type="image/png" href="/icon-192x192.png" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Noto+Sans:wght@400;700&display=swap"
          rel="stylesheet"
        />
        <script
          type="modlie"
          src="https://unpkg.com/ionicons@5.2.3/dist/ionicons/ionicons.esm.js"
        ></script>
        <script src="https://embed.typeform.com/embed.js"></script>
        <meta property="og:title" content={pageTitle} />
        <meta property="og:type" content="website" />
        <meta property="og:description" content={companyDescription} />
        <meta property="og:url" content={websiteUrl} />
        <meta property="og:site_name" content="Craftsman Software" />
        <meta
          property="og:image"
          content="https://craftsman-software.com/ogp-recruit.png"
        />
        <meta property="og:locale" content="ja_JP" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:image"
          content="https://craftsman-software.com/ogp-recruit.png"
        />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={companyDescription} />
      </Helmet>
      <main>
        <img src="/recruit_photo.png" alt="Craftsman Software"/>
        <Mission/>
        <div className={styles.wanted}>
          <div className={styles.inner}>
            <h2 className={styles.title}>応募について</h2>
            <p className="text-center font-bold text-green-500">社員・業務委託OK！</p>
            <a 
              href="https://herp.careers/v1/c16e" 
              className={styles.wanted_link + " block w-64 text-center font-bold tracking-widest text-white text-lg py-5 px-10 rounded-full mx-auto"}
            >
              募集職種一覧
            </a>

            <div>
              <h3>採用フロー</h3>
              <ol className="list-none p-0">
                <li className="bg-white p-3 mb-3 rounded-lg">
                  <div className="inline-block mb-3 align-top border py-1 px-5 text-sm border-green-500 text-green-500">STEP 1</div>
                  <div className="inline-block ml-5">
                    <span className="text-lg text-blue-500 font-semibold">ご応募</span>
                    <p className="mt-2 mb-0 text-sm">募集職種一覧から希望の職種を選択し、「応募する」ボタンからご応募ください。</p>
                  </div>
                </li>
                <li className="bg-white p-3 mb-3 rounded-lg">
                  <div className="inline-block mb-3 align-top border py-1 px-5 text-sm border-green-500 text-green-500">STEP 2</div>
                  <div className="inline-block ml-5">
                    <span className="text-lg text-blue-500 font-semibold">カジュアル面談（希望者のみ）</span>
                    <p className="mt-2 mb-0 text-sm">書類提出は不要です。応募フォームにてカジュアル面談希望の旨をご入力ください。</p>
                  </div>
                </li>
                <li className="bg-white p-3 mb-3 rounded-lg">
                  <div className="inline-block mb-3 align-top border py-1 px-5 text-sm border-green-500 text-green-500">STEP 3</div>
                  <div className="inline-block ml-5">
                    <span className="text-lg text-blue-500 font-semibold">書類選考</span>
                    <p className="mt-2 mb-0 text-sm">いただいた書類を拝見し、選考をさせていただきます。</p>
                  </div>
                </li>
                <li className="bg-white p-3 mb-3 rounded-lg">
                  <div className="inline-block mb-3 align-top border py-1 px-5 text-sm border-green-500 text-green-500">STEP 4</div>
                  <div className="inline-block ml-5">
                    <span className="text-lg text-blue-500 font-semibold">採用面談</span>
                    <p className="mt-2 mb-0 text-sm">2〜3回の面談をオンラインで実施いたします。</p>
                  </div>
                </li>
                <li className="bg-white p-3 mb-3 rounded-lg">
                  <div className="inline-block mb-3 align-top border py-1 px-5 text-sm border-green-500 text-green-500">STEP 5</div>
                  <div className="inline-block ml-5">
                    <span className="text-lg text-blue-500 font-semibold">合否連絡</span>
                    <p className="mt-2 mb-0 text-sm">応募から合否連絡までは2週間ほどかかります。ご了承ください。</p>
                  </div>
                </li>
              </ol>
            </div>
          </div>
        </div>
        <Benefits/>
        <Activities/>
      </main>
      <Footer />
    </div>
  );
}

export default Page;
